module.exports = __webpack_public_path__ + "images/8fa2f572863b929c4d654c7baba97c5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/swimandgoseek-story00.jpg
// module id = ./webpack/assets/img/swimandgoseek-story00.jpg
// module chunks = 0